var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 7.58317C7.32213 7.58317 7.58329 7.322 7.58329 6.99984C7.58329 6.67767 7.32213 6.4165 6.99996 6.4165C6.67779 6.4165 6.41663 6.67767 6.41663 6.99984C6.41663 7.322 6.67779 7.58317 6.99996 7.58317Z",
    fill: "#C2C6D3",
    stroke: "#C2C6D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 3.50016C7.32213 3.50016 7.58329 3.239 7.58329 2.91683C7.58329 2.59466 7.32213 2.3335 6.99996 2.3335C6.67779 2.3335 6.41663 2.59466 6.41663 2.91683C6.41663 3.239 6.67779 3.50016 6.99996 3.50016Z",
    fill: "#C2C6D3",
    stroke: "#C2C6D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 11.6667C7.32213 11.6667 7.58329 11.4055 7.58329 11.0833C7.58329 10.7612 7.32213 10.5 6.99996 10.5C6.67779 10.5 6.41663 10.7612 6.41663 11.0833C6.41663 11.4055 6.67779 11.6667 6.99996 11.6667Z",
    fill: "#C2C6D3",
    stroke: "#C2C6D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.6e0d2db8.svg";
export { ForwardRef as ReactComponent };